import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { hideWishlistOnboarding } from 'src/store/wishlist/actions';
import { isOnboardingShowedSelector } from 'src/store/wishlist/selectors';
import WishlistOnboarding from './WishlistOnboarding';

const mapStateToProps = (state) => ({
  isOnboardingShowed: isOnboardingShowedSelector(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  hideOnboarding: hideWishlistOnboarding,
};

export default connect(mapStateToProps, mapDispatchToProps)(WishlistOnboarding);
